/**
 * PrintState
 */
import {
  PrintActions,
  PrintActionTypes,
} from '@app/core/ngrx/actions/print.actions';

export interface PrintState {
  printTabIndex: number;
}

/**
 * PRINT_INITIAL_STATE
 * @type {{sortBy: string}}
 */
export const PRINT_INITIAL_STATE: PrintState = {
  printTabIndex: 0,
};

/**
 * sortReducer
 * @param {SortState} state
 * @param {SortActions} action
 * @returns {SortState}
 */
export const printReducer = (
  state: PrintState = PRINT_INITIAL_STATE,
  action: PrintActions,
): PrintState => {
  switch (action.type) {
    case PrintActionTypes.LOAD_TAB_INDEX:
      return {
        ...state,
        printTabIndex: action.payload,
      };
    case PrintActionTypes.CLEAR_TAB_INDEX:
      return {
        ...state,
        printTabIndex: 0,
      };
    default:
      return state;
  }
};
